import React, { useEffect, useState } from "react"
import Socials from "./Socials/Socials.jsx"
import Logo from "./Logo/Logo.jsx"
import Banner from "./Banner/Banner.jsx"
import HeaderOrig from "./HeaderOrig.jsx"

export default function HeaderDenise() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      {windowWidth > 1090 ? (
        <>
          <Socials />
          <Logo />
          <Banner />
        </>
      ) : (
        <div>
          <div>
          <HeaderOrig />
          <br />
                    <br />

          </div>
          <br />        
          <Logo />
          <Socials />

        </div>
      )}
    </div>
  );
}

